import React, { useRef } from 'react'
import { Button, Descriptions, Typography } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { useParams } from 'react-router-dom'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import Fetch from '@components/CRUD/Fetch'
import { client } from '@utils/client'

const { Text, Link } = Typography

const Show = () => {
  const { t } = useLocalization()
  const fetchRef = useRef(null)
  const params = useParams()

  const handleReload = () => {
    fetchRef.current.reload()
  }

  const fetch = async () => {
    const result = await client
      .get(`/hospital/${params.id}`)
      .then((res) => res.data)
    return result
  }
  // const data = {
  //   id: 1,
  //   name: 'โรงพยาบาลสมิติเวช',
  //   location: '133 สุขุมวิท 49 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110',
  //   availableTime: '08:00 - 19:00',
  //   telemedUrl: 'https://www.google.com',
  //   specialties: [
  //     { id: 1, name: 'ภูมิแพ้และภูมิคุ้มกัน' },
  //     { id: 2, name: 'มะเร็งและโรคเลือด' },
  //     { id: 3, name: 'กระดูก ข้อ และการกีฬา' },
  //     { id: 4, name: 'สมองและระบบประสาท' },
  //     { id: 5, name: 'เด็กและวัยรุ่น' },
  //   ],
  // }

  return (
    <Fetch fetch={fetch} ref={fetchRef}>
      {(data) => (
        <PageLayout
          title={t('hospital.showScreen.title')}
          editPath={`/hospitals/${params.id}/edit`}
          extra={[
            <Button
              key="reload"
              icon={<ReloadOutlined />}
              onClick={handleReload}
            >
              {t('hospital.showScreen.reload')}
            </Button>,
          ]}
        >
          <Descriptions column={1}>
            <Descriptions.Item
              label={<Text strong>{t('hospital.showScreen.label.name')}</Text>}
            >
              {data.name}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Text strong>{t('hospital.showScreen.label.location')}</Text>
              }
            >
              {data.location}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Text strong>
                  {t('hospital.showScreen.label.availableTime')}
                </Text>
              }
            >
              {data.availableTime}
            </Descriptions.Item>
            <Descriptions.Item
              label={
                <Text strong>{t('hospital.showScreen.label.telemedUrl')}</Text>
              }
            >
              <Link href={data.telemedUrl} target="_blank">
                {data.telemedUrl}
              </Link>
            </Descriptions.Item>
          </Descriptions>
        </PageLayout>
      )}
    </Fetch>
  )
}

export default Show
